<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps({
    typeComponent: {
        type: String,
        default: 'button'
    },
    to: {
        type: String,
        default: ''
    },
    handlerClick: {
        type: Function,
        default: () => {}
    },
    icon: {
        type: [Object, Function],
        default: () => {}
    },
    text: {
        type: String,
        required: true
    },
    badge: {
        type: Object,
        default: () => {}
    }
});

const route = useRoute();
const color = computed(() => {
    const splited = props?.to?.split('/');
    if (splited[1] && route.path.includes(splited[1])) return 'primary';
    else return 'gray';
});
const setClassTypeItem = computed(() => typeItem[color.value]);
const setClassIcon = computed(() => classIcon[color.value]);
const setClassText = computed(() => classText[color.value]);

const typeItem = Object.freeze({
    gray: 'bg-transparent hover:bg-gray-950/5',
    primary: 'bg-white shadow-[0_1px_3px_0_rgb(0_0_0_/_0.1),0_1px_2px_-1px_rgb(0_0_0_/_0.1),0px_0px_0px_1px_rgba(0,0,0,0.10)]'
});

const classIcon = Object.freeze({
    gray: 'text-gray-500',
    primary: 'text-gray-500'
});

const classText = Object.freeze({
    gray: 'text-gray-700',
    primary: 'text-gray-950'
});
</script>

<template>
    <component
        :is="props.typeComponent"
        class="relative flex justify-start items-center px-2 py-1 gap-2.5 rounded-md cursor-pointer antialiased transition ease-linear duration-75"
        :class="`${setClassTypeItem} ${setClassText}`"
        :to="props.to"
        @click="props.handlerClick"
    >
        <div class="flex items-center">
            <component :is="icon" class="w-4 h-4 mr-2.5" :class="setClassIcon"></component>
            <span class="font-medium text-sm">
                {{ props.text }}
            </span>
        </div>
        <div v-if="badge" class="flex justify-center items-center py-1">
            <component :is="badge"></component>
        </div>
    </component>
</template>
